/* Luminate theme JS — Phase 0 scaffold.
   Phase 1 adds: AJAX cart drawer, predictive search, mobile nav drawer, variant picker. */

// Scroll-reveal (replaces framer-motion whileInView for simple cases)
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || els.length === 0) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
})();

// Mobile nav drawer: open/close, accordion groups, Escape, focus to the close button
(function () {
  var nav = document.getElementById('MobileNav');
  if (!nav) return;
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('lum-drawer-open'); // hides the chat bubble while open
    var close = nav.querySelector('[data-mobile-close].lum-mnav__close');
    if (close) setTimeout(function () { close.focus(); }, 320);
  }
  function close() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('lum-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-open]')) { open(); return; }
    if (e.target.closest('[data-mobile-close]')) { close(); return; }
    var toggle = e.target.closest('[data-mnav-toggle]');
    if (toggle && nav.contains(toggle)) {
      var group = toggle.closest('[data-mnav-group]');
      var sub = group && group.querySelector(':scope > .lum-mnav__sub');
      if (!sub) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      // one top-level group open at a time keeps the list short
      if (!expanded && !toggle.classList.contains('lum-mnav__toggle--sub')) {
        nav.querySelectorAll('.lum-mnav__list > [data-mnav-group] > [data-mnav-toggle][aria-expanded="true"]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var s = t.closest('[data-mnav-group]').querySelector(':scope > .lum-mnav__sub');
          if (s) s.hidden = true;
        });
      }
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sub.hidden = expanded;
      if (!expanded) toggle.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
  });
})();

// Mega-menu tab switching (hover the left rail to swap panels)
(function () {
  document.addEventListener('mouseover', function (e) {
    var tab = e.target.closest('[data-menu-tab]');
    if (!tab) return;
    var name = tab.getAttribute('data-menu-tab');
    var panelRoot = tab.closest('.mega-panel');
    if (!panelRoot) return;
    panelRoot.querySelectorAll('[data-menu-tab]').forEach(function (t) {
      var active = t === tab;
      t.classList.toggle('bg-primary', active);
      t.classList.toggle('text-primary-foreground', active);
      t.classList.toggle('hover:bg-muted', !active);
    });
    panelRoot.querySelectorAll('[data-menu-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-menu-panel') !== name;
    });
  });
})();

// Keep header cart count in sync after AJAX cart changes (Phase 1 wires the drawer)
window.LuminateCart = {
  refreshCount: function () {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }
};

// Get Directions dialog (transposes DirectionsDialog.tsx).
// theme.js loads mid-body, before the dialog snippet at the end of <body>,
// so initialization waits for the full DOM.
function initDirectionsDialog() {
  var dlg = document.querySelector('[data-directions-dialog]');
  if (!dlg) return;
  var input = dlg.querySelector('#DirectionsOrigin');
  var go = dlg.querySelector('[data-directions-go]');
  var sugBox = dlg.querySelector('[data-directions-suggestions]');
  var mapsKey = dlg.getAttribute('data-maps-key');
  var DEFAULT_STORE = dlg.getAttribute('data-default-destination') || '486 Starboard Dr, Halifax B3M 0N6';
  // set per-trigger: each Get directions button can name its own store
  var destination = DEFAULT_STORE;
  var placesService = null;
  var placesLoading = false;
  var debounceTimer = null;

  // Places autocomplete (as on the live site) — loads Google Maps JS on first open
  function loadPlaces() {
    if (!mapsKey || placesService || placesLoading) return;
    if (window.google && window.google.maps && window.google.maps.places) {
      placesService = new window.google.maps.places.AutocompleteService();
      return;
    }
    placesLoading = true;
    window.__lumPlacesReady = function () {
      try { placesService = new window.google.maps.places.AutocompleteService(); } catch (e) { /* plain input still works */ }
    };
    var tag = document.createElement('script');
    tag.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(mapsKey) + '&libraries=places&callback=__lumPlacesReady';
    tag.async = true;
    tag.onerror = function () { placesLoading = false; };
    document.head.appendChild(tag);
  }
  function hideSuggestions() {
    if (sugBox) { sugBox.hidden = true; sugBox.innerHTML = ''; }
  }
  function showSuggestions(preds) {
    if (!sugBox || !preds || !preds.length) { hideSuggestions(); return; }
    sugBox.innerHTML = '';
    preds.forEach(function (pr) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'w-full text-left px-4 py-3 hover:bg-muted transition-colors border-b border-border last:border-b-0';
      var main = document.createElement('div');
      main.className = 'font-medium';
      main.textContent = (pr.structured_formatting && pr.structured_formatting.main_text) || pr.description;
      var sec = document.createElement('div');
      sec.className = 'text-sm text-muted-foreground';
      sec.textContent = (pr.structured_formatting && pr.structured_formatting.secondary_text) || '';
      b.appendChild(main);
      b.appendChild(sec);
      b.addEventListener('click', function () {
        input.value = pr.description;
        go.disabled = false;
        hideSuggestions();
        input.focus();
      });
      sugBox.appendChild(b);
    });
    sugBox.hidden = false;
  }
  function fetchSuggestions() {
    var q = input.value.trim();
    if (!placesService || q.length < 3) { hideSuggestions(); return; }
    placesService.getPlacePredictions(
      { input: q, componentRestrictions: { country: 'ca' } },
      function (preds, status) { showSuggestions(status === 'OK' ? preds : null); }
    );
  }

  function open() {
    dlg.hidden = false;
    document.body.style.overflow = 'hidden';
    loadPlaces();
    setTimeout(function () { input.focus(); }, 50);
  }
  function close() {
    dlg.hidden = true;
    document.body.style.overflow = '';
    input.value = '';
    go.disabled = true;
    hideSuggestions();
  }
  function submit() {
    var origin = input.value.trim();
    if (!origin) return;
    window.open('https://www.google.com/maps/dir/?api=1&origin=' + encodeURIComponent(origin) +
      '&destination=' + encodeURIComponent(destination), '_blank');
    close();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-directions-open]');
    if (trigger) {
      e.preventDefault();
      destination = trigger.getAttribute('data-destination') || DEFAULT_STORE;
      var label = dlg.querySelector('[data-directions-destination]');
      if (label) label.textContent = destination;
      open();
      return;
    }
    if (dlg.hidden) return;
    if (e.target.closest('[data-directions-close]') || e.target.closest('[data-directions-close-overlay]')) close();
    else if (e.target.closest('[data-directions-go]')) submit();
  });
  input.addEventListener('input', function () {
    go.disabled = !input.value.trim();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchSuggestions, 500); // same 500ms debounce as the live site
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); hideSuggestions(); submit(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dlg.hidden) close(); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDirectionsDialog);
else initDirectionsDialog();

/* Header condensation — flips a flag at 80px so CSS can shrink the bar. */
(function () {
  var header = document.querySelector('[data-lum-header]');
  if (!header) return;
  var ticking = false;
  function apply() {
    header.setAttribute('data-scrolled', window.scrollY > 80 ? 'true' : 'false');
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }, { passive: true });
  apply();
})();
